import Content from '../../content.js';

namespace('IO.Views.UserGroups', function (exports) {
  'use strict';

  var Show = Content.extend({
    dom: {
      SUDO: 'input[name="user_group[sudo]"]',
      SUDO_COMMANDS: '.sudo-commands',
      DELETE_BUTTON: '.alert.button',
    },

    render: function () {
      this._checkSudoCommands();
      $(this.dom.DELETE_BUTTON).on('click', this._warnIccImpact);
    },

    _checkSudoCommands: function () {
      var self = this,
        sudoCommands;

      $(this.dom.SUDO).change(function () {
        sudoCommands = $(self.dom.SUDO_COMMANDS);
        if (this.value == 'true') {
          sudoCommands.removeClass('hidden');
        } else {
          sudoCommands.addClass('hidden');
        }
      });
    },

    _warnIccImpact: function (e) {
      var warnModal,
        url = location.href;

      if (url.indexOf('?customer') > -1) {
        url = url.replace('?customer=', '/impact?customer=');
      } else {
        url += '/impact';
      }

      if (!$(e.target).hasClass('triggered')) {
        e.preventDefault();

        warnModal = new IO.Views.Components.ConfirmationDialog({
          url: url,
          jst_template: 'user_groups/impacted', // eslint-disable-line camelcase
          method: 'GET',
        });
        warnModal.impact();
        warnModal.answer(function (proceed) {
          if (proceed) {
            $(e.target).addClass('triggered').trigger('click');
          }
          warnModal.destroy();
        });
        return false;
      }
    },
  });

  exports.Show = Show;
});
